/** @format */
import { smallTablet } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    .sort-by-select {
        margin-bottom: 0;
    }

    > div {
        margin-bottom: 0; /* Removes validation margin */
    }

    ${smallTablet(css`
        width: 100%;
        align-items: center;
        justify-content: center;
        > div {
            width: 100%;
            height: 100%;
            padding-bottom: 0.2rem;
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
